const PROD = true;
const BASE_URL = PROD
  ? "https://backrovirosa.filmoteca.unam.mx"
  // : "http://132.247.164.2:8088";
  //: "http://localhost:8088";
  : "http://192.168.10.100:8088";

async function callApiResponse(endpoint, options = {}) {
  options.headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };
  const url = BASE_URL + endpoint;
  const response = await fetch(url, options);
  return response;
}

async function callApiJson(endpoint, options = {}) {
  options.headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };
  const url = BASE_URL + endpoint;
  const response = await fetch(url, options);
  const data = await response.json();
  return data;
}

const api = {
  movies: {
    list(year) {
      return callApiJson("/rovirosa/titulosRovirosa/" + year);
    },
    create(badge) {
      return callApiJson(`/movies`, {
        method: "POST",
        body: JSON.stringify(badge),
      });
    },
    read(badgeId) {
      return callApiJson(`/movies/${badgeId}`);
    },
    update(badgeId, updates) {
      return callApiJson(`/movies/${badgeId}`, {
        method: "PUT",
        body: JSON.stringify(updates),
      });
    },
    // Lo hubiera llamado `delete`, pero `delete` es un keyword en JavaScript asi que no es buena idea :P
    remove(badgeId) {
      return callApiJson(`/movies/${badgeId}`, {
        method: "DELETE",
      });
    },
  },
  votes: {
    send(binVoto) {
      return callApiResponse(`/rovirosa/recibeVoto`, {
        method: "POST",
        body: JSON.stringify(binVoto),
      });
    },
    validate(token) {
      return callApiResponse("/rovirosa/confirmaVotoRovirosa?token=" + token);
    },
  },
};

export default api;
